import { render, staticRenderFns } from "./SimpleTextContent.vue?vue&type=template&id=40f1f91c&scoped=true&"
import script from "./SimpleTextContent.vue?vue&type=script&lang=js&"
export * from "./SimpleTextContent.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTextContent.vue?vue&type=style&index=0&id=40f1f91c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f1f91c",
  null
  
)

export default component.exports